import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';

const Faqs = () => {
  const [openIndex, setOpenIndex] = useState(0);
  const { t } = useTranslation();

  const faqs = t('faqs.items', { returnObjects: true }) || [];

  const toggleFaq = (index) => {
    setOpenIndex(openIndex === index ? -1 : index);
  };

  return (
    <div className="mt-[78px] px-4 sm:px-6 lg:px-8">
      <div className="max-w-[1280px] mx-auto pt-[92px] pb-[100px]">
        <h1 className="text-[48px] leading-[64px] font-normal tracking-[-1.5px] libre-baskerville text-[#0A0A0A] text-center">
          {t('faqs.title')}{' '}
          <span className="text-[#5D2E5D]">{t('faqs.highlight')}</span>
        </h1>
        <p className="mt-3 text-[#0A0A0A] text-[20px] leading-[32px] font-normal text-center">
          {t('faqs.subtitle')}
        </p>
        <div className="mt-[90px] max-w-[800px] mx-auto w-full">
          <div className="space-y-0">
            {faqs.map((faq, index) => (
              <div
                key={index}
                className="border-b border-[#F2EEEE] last:border-b-0"
              >
                <button
                  onClick={() => toggleFaq(index)}
                  className={`w-full text-left flex items-center justify-between transition-colors duration-200 ${
                    openIndex === index
                      ? 'px-4 sm:px-[24px] pt-[24px] pb-0'
                      : 'px-4 py-6 sm:p-[24px]'
                  }`}
                >
                  <span className="text-[16px] leading-[24px] font-bold text-[#262626] pr-4">
                    {index + 1}. {faq.question}
                  </span>
                  <button className="bg-[#F5F5F5] min-w-6 h-6 flex items-center justify-center">
                    <svg
                      width="16"
                      height="16"
                      className={`transform transition-transform duration-200 ${openIndex === index ? 'rotate-180' : ''}`}
                      viewBox="0 0 16 16"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path d="M8 10L5 7H11L8 10Z" fill="#262626" />
                    </svg>
                  </button>
                </button>
                {openIndex === index && (
                  <div className="px-4 sm:px-[24px] pb-[24px] pt-[16px] text-left">
                    <p className="text-[#404040] text-[16px] leading-[24px] font-normal tracking-tight">
                      {faq.answer}
                    </p>
                  </div>
                )}
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Faqs;
